<template>
    <div>
        <app-header></app-header>
        <div class="container">
            <h2>Добавить новое видео</h2>
            <form>
                <div class="form-group">
                    <label for="exampleInputEmail1">Название</label>
                    <input v-model="name" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Название">
                    <label for="exampleInputEmail1">Ссылка</label>
                    <input v-model="link" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Ссылка">
                    <label for="exampleInputEmail1">Категория</label>
                    <select v-model="cat_id" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Категория">
                        <option v-for="item in ADMIN_CATS" :value="item.id" :key="item.id">{{item.name}}</option>
                    </select>
                    <label for="exampleInputEmail1">Описание</label>
                    <textarea v-model="description" class="form-control" rows="6" placeholder="Описание"></textarea>
                </div>
                <button @click.prevent="addVideo()" type="submit" class="btn btn-primary">Submit</button>
            </form>
            <hr>
            <h2>Добавленные видео</h2>
            <form v-for="item in ADMIN_PRODUCTS.data" :key="item.id">
                <div class="form-group">
                    <label for="exampleInputEmail1">Ссылка</label>
                    <input v-model="item.link" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Ссылка">
                    <label for="exampleInputEmail1">Описание</label>
                    <textarea v-model="item.description" class="form-control" rows="6"></textarea>
                </div>
                <div>
                    <div v-html="item.link"></div>
                </div>
                <button @click.prevent="deleteProducts(item.id)" style="margin-right: 20px;" class="btn btn-danger">Удалить</button>
                <button @click.prevent="editProducts(item.link, item.description, item.cat_id.id, item.id)" class="btn btn-primary">Изменить</button>
            </form>
        </div>
        <modal-box v-if="box" @close="box = false" :title="title"></modal-box>
    </div>
</template>

<script>
    import AppHeader from '@/components/header/'
    import { mapGetters } from 'vuex'
    import ModalBox from '@/components/modalbox'
    export default {
        data() {
            return {
                link: '',
                name: '',
                description: '',
                cat_id: null,
                title: '',
                box: false
            }
        },
        computed: {
            ...mapGetters([
                'ADMIN_PRODUCTS',
                'ADMIN_CATS'
            ])
        },
        methods: {
            addVideo() {
                this.$store.dispatch('POST', [
                    {
                        name: this.name,
                        link: this.link,
                        description: this.description,
                        cat_id: this.cat_id
                    },
                    { name: 'post_products' }
                ])
                this.title = 'Видео создан!';
                this.box = false;
                this.repeat();
                this.name = '';
                this.description = '';
                this.link = '';
            },
            deleteProducts(id){
                let ask = confirm('Вы точно хотите удалить видео?');
                if(ask){
                    this.$store.dispatch('DELETE', [
                        { id: id },
                        { name: 'admin_products' }
                    ])
                    this.title = 'Видео удален!';
                    this.box = false;
                    this.repeat();
                }
            },
            editProducts(link, description, cat_id, id){
                console.log(id)
                this.$store.dispatch('POST_UPDATE', [
                    {
                        link: link,
                        description: description,
                        '_method': 'PATCH'
                    },
                    { name: 'post_products' },
                    { id: id }
                ])
                this.title = 'Видео изменен!';
                this.box = false;
                this.repeat();
            },
            repeat(){
                setTimeout(() => {
                    this.$store.dispatch('GET', [
                        { },
                        { name: 'admin_products' }
                    ]);
                }, 500);
            }
        },
        components: {
            AppHeader,
            ModalBox
        },
        created () {
            this.repeat();
        },
    }
</script>

<style scoped>
    .header-section{
        background: #3A3B40;
    }
    .container{
        margin-top: 140px;
    }
</style>